export default __webpack_public_path__ + "static/media/icon-suction-temperature-compressor.66fd5f6c.svg";